export default "__VITE_ASSET__Dl7ck6WR__"